export const heroVideo = () => {
    window.addEventListener('load', function () {
        const video = document.getElementById('video-hero');

        if (video && window.getComputedStyle(video).display !== 'none') {
            const children = video.getElementsByTagName('source');

            for (let i = 0; i < children.length; i++) {
                children[i].src = children[i].dataset.src;
            }

            video.load();
        }
    });
};
